/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SettingDefs from './defs.defs.js'

const $nsid = 'tools.ozone.setting.upsertOption'

export { $nsid }

/** Create or update setting option */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    key: l.string({ format: 'nsid' }),
    scope: l.string<{ knownValues: ['instance', 'personal'] }>(),
    value: l.lexMap(),
    description: l.optional(l.string({ maxLength: 2000 })),
    managerRole: l.optional(
      l.string<{
        knownValues: [
          'tools.ozone.team.defs#roleModerator',
          'tools.ozone.team.defs#roleTriage',
          'tools.ozone.team.defs#roleVerifier',
          'tools.ozone.team.defs#roleAdmin',
        ]
      }>(),
    ),
  }),
  l.jsonPayload({
    option: l.ref<SettingDefs.Option>((() => SettingDefs.option) as any),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
